import React from 'react';
import { useHistory } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import AdminFooter from '../../components/AdminFooter';
import { logout } from '../../services/authService';
import logger from '../../services/logger';
import '../../styles/admin.css';
import '../../styles/admin-theme-overrides.css';

const AdminLayout = ({ user, children }) => {
  const history = useHistory();
  const [collapsed, setCollapsed] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      logger.error('Logout failed', { requestId: error.requestId });
    } finally {
      history.replace('/admin/login');
    }
  };

  return (
    <div className={`admin-shell ${collapsed ? 'sidebar-collapsed' : ''} ${mobileOpen ? 'mobile-sidebar-open' : ''}`}>
      <AdminSidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        onNavigate={() => setMobileOpen(false)}
      />
      <div className="admin-main-column">
        <AdminHeader user={user} onMenuToggle={() => setMobileOpen(!mobileOpen)} onLogout={handleLogout} />
        <main className="admin-content">{children}</main>
        <AdminFooter />
      </div>
    </div>
  );
};

export default AdminLayout;
